import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.reports.bills'),
        name: 'reports.bill',
        component: () =>
            import(
                /* webpackChunkName: "reports" */ '@/views/reports/bills/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('reports.breadcrumbs.bills'),
                    to: { name: 'reports.bill' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.reports.bookings'),
        name: 'reports.bookings',
        component: () =>
            import(
                /* webpackChunkName: "reports" */ '@/views/reports/bookings/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.reports.breadcrumb.bookings'),
                    to: { name: 'reports.bookings' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.reports.resellers'),
        name: 'reports.resellers',
        component: () =>
            import(
                /* webpackChunkName: "reports" */ '@/views/reports/resellers/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: 'Relatório de Parceiros',
                    to: { name: 'reports.resellers' },
                    disable: true,
                },
            ],
        },
    },
]
